import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hoursMinutes'
})
export class HoursMinutesPipe implements PipeTransform {
  transform(value: number): string {
    if (value == null || isNaN(value)) {
		return '0h 0m';
	}

    const hours: number = Math.floor(value);
    const minutes: number = Math.round((value - hours) * 60);

    return `${hours.toString()}h ${minutes.toString()}m`;
  }
}
